import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, User, Trash2 } from 'lucide-react';
import { supabase } from '../supabase';
type Booking = {
  id: string;
  nama_lengkap: string;
  kelas: string;
  no_hp: string;
  topik: string;
  metode: string;
  metode_virtual: string | null;
  jadwal: string;
  created_at: string;
};
export function BimbinganBooking() {
  const [data, setData] = useState<Booking[]>([]);
  const [loading, setLoading] = useState(true);

  // ================= FETCH =================
  const fetchData = async () => {
    setLoading(true);
    const {
      data: userData
    } = await supabase.auth.getUser();
    const user = userData.user;
    if (!user) {
      setLoading(false);
      return;
    }
    const {
      data,
      error
    } = await supabase.from('bimbingan_bookings').select('*').eq('user_id', user.id).order('created_at', {
      ascending: false
    });
    if (!error && data) {
      setData(data);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);

  // ================= DELETE =================
  const handleDelete = async (id: string) => {
    const confirm = window.confirm('Yakin ingin hapus booking ini?');
    if (!confirm) return;
    const {
      error
    } = await supabase.from('bimbingan_bookings').delete().eq('id', id);
    if (error) {
      alert('Gagal menghapus');
      return;
    }
    setData(prev => prev.filter(item => item.id !== id));
  };

  // ================= FORMAT DATE (FIX WIB) =================
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('id-ID', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Jakarta'
    });
  };
  return <div className="min-h-screen bg-white py-10 px-4" data-id="element-213">

      <div className="max-w-5xl mx-auto" data-id="element-214">

        {/* HEADER */}
        <div className="text-center mb-10" data-id="element-215">
          <h1 className="text-3xl font-bold text-dark" data-id="element-216">
            Riwayat Booking Bimbingan
          </h1>
          <p className="text-gray-500 text-sm mt-2" data-id="element-217">
            Semua jadwal yang sudah kamu ajukan
          </p>
        </div>

        {/* LOADING */}
        {loading && <div className="text-center text-gray-500" data-id="element-218">
            Loading data...
          </div>}

        {/* EMPTY */}
        {!loading && data.length === 0 && <div className="text-center text-gray-500 bg-gray-50 p-10 rounded-2xl" data-id="element-219">
            Belum ada booking
          </div>}

        {/* LIST */}
        <div className="space-y-4" data-id="element-220">

          {data.map(item => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-white border rounded-2xl p-5 shadow-sm" data-id="element-221">

              {/* HEADER */}
              <div className="flex justify-between items-start mb-3" data-id="element-222">

                <div className="flex items-center gap-3" data-id="element-223">

                  <div className="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center" data-id="element-224">
                    <User size={18} className="text-blue-600" data-id="element-225" />
                  </div>

                  <div data-id="element-226">
                    <h3 className="font-semibold" data-id="element-227">
                      {item.nama_lengkap}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-228">
                      {item.kelas} • {item.no_hp}
                    </p>
                  </div>

                </div>

                {/* DELETE BUTTON (NO EDIT) */}
                <button onClick={() => handleDelete(item.id)} className="text-red-500 hover:bg-red-50 p-2 rounded-lg" data-id="element-229">
                  <Trash2 size={16} data-id="element-230" />
                </button>

              </div>

              {/* TOPIK */}
              <p className="text-sm text-gray-700 mb-3" data-id="element-231">
                {item.topik}
              </p>

              {/* METODE */}
              <span className="text-xs px-3 py-1 rounded-full bg-gray-100 inline-block mb-2" data-id="element-232">
                {item.metode}
              </span>

              {/* DETAIL */}
              {item.metode_virtual && <p className="text-xs text-gray-500 mb-2" data-id="element-233">
                  Virtual: {item.metode_virtual}
                </p>}

              {/* FOOTER */}
              <div className="flex flex-col gap-1 text-xs text-gray-500" data-id="element-234">

                <div className="flex items-center gap-1" data-id="element-235">
                  <Calendar size={12} data-id="element-236" />
                  Jadwal: {formatDate(item.jadwal)}
                </div>

                <div className="flex items-center gap-1" data-id="element-237">
                  <Clock size={12} data-id="element-238" />
                  Dibuat: {formatDate(item.created_at)}
                </div>

              </div>

            </motion.div>)}

        </div>

      </div>
    </div>;
}